import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import AvatarPlaceholder from '../../assets/images/mock/default-profile-icon.png'
import SmallMilestoneIcon from '../common/SmallMilestoneIcon'

import classes from './AccountCard.module.scss'
import SubmitButton from '../common/buttons/SubmitButton'
import TooltipText from '../common/TooltipText'

const AccountCard = ({
  avatarUrl, fullName, email, age, familyAdmin, division, className, allowReinvite, pendingInvitation, onResendInvitation, membershipActive,
}) => {
  const { t } = useTranslation()
  const userDisplayName = pendingInvitation ? fullName : t('account.card.nameAge', { name: fullName, age })

  const handleReinvite = (e) => {
    e.preventDefault()
    onResendInvitation()
  }

  return (
    <article className={classNames(classes.accountCard, { [className]: className }, 'd-flex align-items-center')}>
      {!pendingInvitation && (
        <div className={classNames(classes.accountVisuals, 'mr-3')}>
          <div className='medium-round-image-wrapper'>
            <img
              className='round-image'
              src={avatarUrl || AvatarPlaceholder}
              alt={t('account.card.avatarAlt')}
            />
          </div>

          <div className={classNames(classes.divisionWrapper)}>
            <SmallMilestoneIcon division={division || 1} fromAvatar />
          </div>
        </div>
      )}

      <div className={classNames(classes.accountInfo, 'd-flex flex-column justify-content-center align-items-left')}>
        <p className={classes.fullName}>{userDisplayName}</p>

        {pendingInvitation && (
          <TooltipText text={email} className={classes.smallText} />
        )}


        {pendingInvitation && (
          <span className={classes.specialText}>{t('account.card.pendingInvitation')}</span>
        )}

        {!pendingInvitation && familyAdmin && (
          <span className={classes.specialText}>{t('common.studentCard.familyAdmin')}</span>
        )}
      </div>

      {!pendingInvitation && membershipActive !== undefined && (
        <span className={classNames(classes.membershipBadge, membershipActive ? classes.membershipActive : classes.membershipLocked)}>
          {membershipActive ? t('account.card.membershipActive') : t('account.card.membershipLocked')}
        </span>
      )}

      {pendingInvitation && allowReinvite && (
        <SubmitButton
          onClick={handleReinvite}
          buttonMessage={t('account.card.reinvite')}
          buttonColor='orange-button'
          className={classes.resendButton}
        />
      )}
    </article>
  )
}

AccountCard.propTypes = {
  avatarUrl: PropTypes.string,
  fullName: PropTypes.string,
  email: PropTypes.string,
  age: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  familyAdmin: PropTypes.bool,
  className: PropTypes.string,
  division: PropTypes.number,
  allowReinvite: PropTypes.bool,
  pendingInvitation: PropTypes.bool,
  onResendInvitation: PropTypes.func,
  membershipActive: PropTypes.bool,
}

export default AccountCard
